<template>
  <div>
    <ed-form :model="formData">
      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        label="Empresa"
        v-model="formData.id_emp"
        :items="lstEmpresa"
        :loading="loadingEmpresa"
        @input="getFuncionario"
        @search="getEmpresa"
        clearable
        remote
      />

      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
        label="Trabalhador"
        v-model="formData.id_fun"
        :items="lstFuncionario"
        :loading="loadingFuncionario"
        @search="getFuncionario"
        clearable
        remote
      />

      <ed-input-date
        class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
        label="Data de Início do Periodo"
        v-model="formData.data_inicio"
      />

      <ed-input-date
        class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
        label="Data de Final do Periodo"
        v-model="formData.data_fim"
      />

      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-5">
        <ed-button
          type="success"
          label="Consultar Informações no eSocial"
          icon="fa fa-search"
          :loading="loading"
          :disabled="!formData.id_emp || !formData.id_fun || !formData.data_inicio || !formData.data_fim ? true : false"
          @click="consultar"
        />
      </div>
    </ed-form>

    <div class="consulta-esocial-erro" v-if="erro">
      <i class="fa fa-exclamation-triangle"></i>
      <span>{{ erro }}</span>
    </div>

    <div class="col-12 mt-5" v-if="formData.strXml">
      <div class="consulta-esocial-contexto">
        <div class="consulta-esocial-contexto__item">
          <span class="consulta-esocial-contexto__label">Trabalhador</span>
          <span class="consulta-esocial-contexto__value">{{ consultadoEm.funcionario }}</span>
        </div>
        <div class="consulta-esocial-contexto__item">
          <span class="consulta-esocial-contexto__label">Período</span>
          <span class="consulta-esocial-contexto__value">{{ consultadoEm.periodo }}</span>
        </div>
        <div class="consulta-esocial-contexto__item">
          <span class="consulta-esocial-contexto__label">Empresa</span>
          <span class="consulta-esocial-contexto__value">{{ consultadoEm.empresa }}</span>
        </div>
        <div class="consulta-esocial-contexto__item">
          <span class="consulta-esocial-contexto__label">Consultado em</span>
          <span class="consulta-esocial-contexto__value">{{ consultadoEm.data }}</span>
        </div>
      </div>

      <h4><b>Informações no eSocial</b></h4>

      <XmlViewer :xml="formData.strXml" />
    </div>
  </div>
</template>

<script>
import XmlViewer from "vue-xml-viewer";
import Rest from "common/rest";
import { EdForm, EdButton, EdInputSelect, EdInputText, EdInputDate } from "template";

export default {
  name: "esocial-lotes-reenviar-email",
  mixins: [Rest],
  components: {
    XmlViewer,
    EdForm,
    EdButton,
    EdInputSelect,
    EdInputText,
    EdInputDate,
  },

  props: {
    lstEmpresa: {
      type: [Array],
      default: [],
    },
    loadingEmpresa: {
      type: Boolean,
      default: false,
    },
  },
  inject: ["getEmpresa", "getLayout"],
  watch: {
    lstEmpresa: {
      handler: function (newVal) {},
      deep: true,
    },
    loadingEmpresa() {},
  },

  data() {
    return {
      formData: {
        id_emp: null,
        id_fun: null,
        layout: null,
        busca: null,
        strXml: null,
      },
      lstFuncionario: [],
      loadingFuncionario: false,
      loading: false,
      erro: null,
      consultadoEm: {},
    };
  },

  created() {},

  mounted() {},

  methods: {
    getFuncionario(_search) {
      if (!this.formData.id_emp) return;

      this.lstFuncionario = [];
      this.loadingFuncionario = true;

      this.get("/empresa/funcionario/" + this.formData.id_emp, {
        search: _search,
      }).then((result) => {
        result = result[0];
        if (result.status == 200) {
          this.lstFuncionario = result.data.data;
        }
        this.loadingFuncionario = false;
      });
    },

    consultar() {
      this.loading = true;
      this.erro = null;
      this.formData.strXml = null;

      this.$root.$request
        .post(
          "esocial/lotes/consultar/" + this.formData.id_emp + "/" + this.formData.id_fun + "/evento-funcionario",
          this.formData
        )
        .then((result) => {
          this.loading = false;

          if (result.status == 200) {
            this.formData.strXml = result.data;
            this.consultadoEm = {
              funcionario: this.funcionarioSelecionado(),
              periodo: this.formData.data_inicio + " a " + this.formData.data_fim,
              empresa: this.empresaSelecionada(),
              data: this.toDate(new Date()),
            };
          } else {
            this.erro = result.msg || "Não foi possível consultar os eventos do trabalhador no eSocial.";
          }
        });
    },

    empresaSelecionada() {
      var empresa = (this.lstEmpresa || []).find((e) => e.id == this.formData.id_emp);
      return empresa ? empresa.nome : this.formData.id_emp;
    },

    funcionarioSelecionado() {
      var funcionario = (this.lstFuncionario || []).find((f) => f.id == this.formData.id_fun);
      return funcionario ? funcionario.nome : this.formData.id_fun;
    },

    toDate(date) {
      return new Date(date).toLocaleString("pt-BR");
    },
  },
};
</script>

<style lang="scss" scoped>
.consulta-esocial-erro {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  background: rgba(192, 57, 43, 0.08);
  color: #c0392b;
  font-size: 12px;

  i {
    font-size: 14px;
  }
}

.consulta-esocial-contexto {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 14px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #f7f9fb;
  border: 1px solid #eef0f2;
}

.consulta-esocial-contexto__item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.consulta-esocial-contexto__label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #9aa0a8;
}

.consulta-esocial-contexto__value {
  font-size: 12px;
  color: #1f2329;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// consulta-evento-trabalhador.vue?74b3b838